import RenderRoutes from './RenderRoutes'

export default RenderRoutes
